var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"ml-2 mt-2",attrs:{"input-value":_vm.active,"depressed":"","active-class":"primary white--text"},on:{"click":function($event){return _vm.$emit('toggle', $event)}}},[(_vm.icon)?_c('v-icon',{attrs:{"left":""},domProps:{"textContent":_vm._s(_vm.icon)}}):_vm._e(),_vm._v("\n  "+_vm._s(_vm.paymentMethod.name)+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }